/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-08-21 18:13:58
 * @FilePath: \sns-user-frontend\src\service\frontend.js
 * @Description: frontend port 后台配置
 */


import { get, post } from './http'

const frontendPath = '/operate/frontend/'

const frontend = {
  // 获取云平台配置
  getCloudConfig: () => {
    return get('operate/frontend/settings/get')
  },
  // 获取登录链接
  getLoginUrl: (params) => {
    return get(`${frontendPath}sso/pcLoginUrl`, params)
  },
  // 获取登出链接
  getLogoutUrl: (params) => {
    return get(`${frontendPath}sso/pcLogoutUrl`, params)
  },
  // 获取banner图
  getBannerList: () => {
    return get(`${frontendPath}banner/rotationList`)
  },
  // 获取首页推荐卡片
  getRecommendedCard: () => {
    return get(`${frontendPath}banner/pieceList`)
  },
  // 获取最佳创作者
  getTopCreators: () => {
    return get(`${frontendPath}koc/list`)
  },
  // 获取活跃度排行榜
  getActiveRanking: (params) => {
    return get(`${frontendPath}koc/populars`, params)
  },
  // 获取隐私协议历史版本
  getPrivacyHistory: () => {
    return get(`${frontendPath}privacy/history`)
  },
  // 获取一键参与 预设内容
  getPresetContent:(params) => {
    return get(`${frontendPath}thread/template/get`,params)
  },
  // 获取全站公告
  getNoticeList: () => {
    return get(`${frontendPath}notice/list`)
  },
}


export default frontend